<template>
  <div>
    <Breadcrumbs main="Contact Center Portal" title="Agent Desktop" />
    <!-- Container-fluid starts-->
    <div id="container-fluid" class="container-fluid">
      <div class="row d-flex justify-content-between" style="overflow-x: hidden">
        <div :class="show ? 'col-3' : 'col-0 '">
          <div class="card" style="height: 80vh; overflow-y: none" ref="ScrollMessageChat">
            <b-tabs class="p-3" v-model="tab1" nav-class="menu" content-class="mt-3" no-nav-style no-fade>
              <template #tabs-start>
                <transition name="fade">
                  <p class="m-0 d-flex align-item-bottom">
                    <b-button variant="traparent" class="icofont icofont-circled-left p-0 text-primary btn-pill"
                      style="font-size: xx-large" @click="show = !show">
                    </b-button>
                  </p>
                </transition>
              </template>
              <b-tab v-for="(item, i) in tabL" :key="item + i" :title-link-class="linkClass(tab1, i)"
                title-item-class="transition" :title="item.tab" :active="i == 0">
                <component :is="item.content" @template="email" />
              </b-tab>
            </b-tabs>
          </div>
        </div>
        <div :class="show ? 'col-9 ' : 'col-12'">
          <div class="card row justify-content-between" style="height: 80vh; overflow-y: none">
            <b-tabs :class="getClass(contentHistory, show)" class="p-3 trasition" v-model="tab2"
              content-class="mt-3 overflow-scroll" no-nav-style>
              <template #tabs-start>
                <!-- <transition name="fade"> -->
                <em v-if="!show" class="m-0 pl-3 d-flex align-item-bottom">
                  <b-button variant="traparent" class="icofont icofont-circled-right p-0 text-primary btn-pill"
                    style="font-size: xx-large" @click="
                      show = !show;
                    tab1 = 1;
                    ">
                  </b-button>
                </em>
                <!-- </transition> -->
              </template>
              <template #tabs-end v-if="showHistory">
                <transition name="fade">
                  <em v-if="!contentHistory && tab2 == 1"
                    class="m-0 pl-3 d-flex align-item-bottom justify-content-end history-tab">
                    <b-button variant="traparent" class="icofont icofont-circled-left p-0 text-primary btn-pill"
                      style="font-size: xx-large" @click="contentHistory = !contentHistory">
                    </b-button>
                  </em>
                </transition>
              </template>
              <!-- <b-tab v-for="(item, i) in tabR" :key="item + i" :title-link-class="linkClass(tab2, i)" :title="item.tab" :active="i == 0">
                            <component :is="item.content" @resetId="resetHistory"  :data="select" :scrollId="scrollId"/>
                          </b-tab> -->
              <b-tab :title-link-class="linkClass(tab2, 0)" title="Agent Status Summary" :active="true">
                <Status ref="agent-desktop-status"></Status>
              </b-tab>
              <b-tab :title-link-class="linkClass(tab2, 1)" title="Mail Massage">
                <Massage ref="agent-desktop-message" @resetId="resetHistory" :data="select" :scrollId="scrollId">
                </Massage>
              </b-tab>
              <b-tab :title-link-class="linkClass(tab2, 2)" title="Job History" @click="selectHistory">
                <History ref="agent-desktop-history"></History>
              </b-tab>
            </b-tabs>
            <div :class="contentHistory ? 'col-4 border-left pr-0 ' : 'col-0'" v-if="showHistory">
              <transition name="history">
                <div v-if="tab2 == 1" class="pt-3">
                  <div class="d-flex align-items-center" style="
                      padding-left: 0em;
                      transition: all 0.4s cubic-bezier(0.6, 0.15, 0.35, 0.8);
                    " :style="show ? '' : 'padding-left:3%'">
                    <b-button variant="traparent" class="icofont icofont-circled-right p-0 text-primary btn-pill"
                      style="font-size: xx-large" @click="toggleHistory">
                    </b-button>
                    <div class="text-primary f-w-500 ml-2" style="font-size: 1.1rem">
                      Content History
                    </div>
                  </div>
                  <div style="height: 74.2vh; overflow-y: scroll">
                    <ContentHistory @scrollTo="scroll" @openHistory="toggleHistory" ref="history" />
                  </div>
                </div>
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { requestService } from './../../_services';
import ContentHistory from '../../components/desktop/content-history.vue';
import Pending from '../../components/desktop/pending.vue';
import Template from '../../components/desktop/template.vue';
import Status from '../../components/desktop/status.vue';
import Massage from '../../components/desktop/massage.vue';
import History from '../../components/desktop/history.vue';
export default {
  components: {
    Pending,
    Template,
    Status,
    Massage,
    History,
    ContentHistory,
  },
  data() {
    return {
      scrollId: null,
      WorkerIO: null,
      show: true,
      select: null,
      tab1: null,
      tab2: null,
      contentHistory: false,
      tabL: [
        {
          tab: 'Pending Job',
          content: 'Pending',
        },
        {
          tab: 'Template',
          content: 'Template',
        },
      ],
      tabR: [
        {
          tab: 'Agent Status Summary',
          content: 'status',
        },
        {
          tab: 'Mail Massage',
          content: 'massage',
        },
        {
          tab: 'Job History',
          content: 'history',
        },
      ],
      showHistory: false,
      allQueue: [],
    };
  },
  watch: {
    tab2(newValue, oldValue) {
      if (newValue !== 1) {
        this.contentHistory = false;
      }
    },
  },

  async mounted() {
    const self = this;
    // await self.connectSharedWorker();
    await self.getAllQueue();
    this.$root.$on('setAgentDesktopTab', (data) => {
      self.tab2 = data;
    });
    this.$root.$on('realtimeQueue', (data) => {
      self.getDashboard();
    });
    this.$root.$on('reloadPendingJob', (data) => {
      self.tab2 = 0;
      self.showHistory = false;
      self.getJobPending();
      self.getDashboard();
    });
    this.$root.$on('setShowContentHistory', (data) => {
      self.showHistory = data;
    });
    await self.getJobPending();
    await self.getDashboard();
  },
  beforeDestroy() {
    this.$root.$off('setAgentDesktopTab', null);
    this.$root.$off('reloadPendingJob', null);
    this.$root.$off('setShowContentHistory', null);
  },
  methods: {
    getAllQueue() {
      let url = `/api/mail/queue_management`;
      requestService
        .GetFetch('ccp', url)
        .then((res) => {
          if (res.status == 200) {
            res.text().then((text) => {
              const data = text && JSON.parse(text);
              let userinfo = localStorage.getItem('userinfo');
              userinfo = JSON.parse(userinfo);
              // console.log('daa:', data.data)
              let myQueues = data.data.filter((obj) => {
                return (
                  obj.member.some((memberId) => memberId == userinfo.user_id) &&
                  obj.status
                );
              });
              // console.log('myQueues: ', myQueues)
              this.allQueue = myQueues;
            });
          }
        })
        .catch((err) => {
          console.log('err: ', err);
        });
    },
    async selectHistory() {
      this.$refs['agent-desktop-history'].loadItems();
    },
    toggleHistory() {
      this.contentHistory = !this.contentHistory;
    },
    resetHistory() {
      this.scrollId = null;
    },
    email(item) {
      this.select = item;
    },
    scroll(id) {
      this.scrollId = id;
    },
    async connectSharedWorker() {
      let self = this;
      if (window.Worker) {
        let userinfo = localStorage.getItem('userinfo');
        userinfo = JSON.parse(userinfo);
        //let url = 'ws://dev_autodialer.cloudcentric.app/itone/socket/ws?';
        let url =
          process.env.NODE_ENV === 'production'
            ? 'wss://itonecsp-ws.cloudcentric.app/itone/socket/ws?'
            : 'wss://itonecsp-dev.cloudcentric.app/ws-api/ws?'
        // : 'wss://itonecsp-dev.cloudsoft.co.th/ws-api/ws?';
        //let url = process.env.NODE_ENV === 'production'? 'wss://itonecsp-ws.cloudcentric.app/itone/socket/ws?': 'ws://localhost:4011/ws?';

        let obj = {
          key: userinfo.access_token,
          id: userinfo.user_id,
        };
        for (var key in obj) {
          if (url != '') {
            url += '&';
          }
          url += key + '=' + encodeURIComponent(obj[key]);
        }
        this.WorkerIO = new SharedWorker(
          './../worker.js?url=' + url,
          'NDN-Worker'
        );
        this.WorkerIO.port.start();
        this.$root.$data.WorkerIO = this.WorkerIO;
        this.WorkerIO.port.addEventListener(
          'message',
          function (eventM) {
            var data = eventM.data;
            var msg = data[0];
            if (msg == 'server') {
              switch (data[1]) {
                case 'ping':
                  self.WorkerIO.port.postMessage('pong');
                  break;
                case 'disconnected':
                  self.WorkerIO.port.postMessage('pong');
                  break;
              }
            } else {
              let dataParse = JSON.parse(data[1]);
              if (msg == 'socketEvent') {
                switch (dataParse['name']) {
                  case 'updateStatus':
                    self.$root.$emit('updateStatus', dataParse['data']);
                    break;
                  case 'realtimeQueue':
                    self.$root.$emit('realtimeQueue', dataParse['data']);
                    break;
                  case 'notification to agent':
                    self.$root.$emit('notificationToAgent', dataParse['data']);
                    self.tab2 = 1;
                    break;
                }
              } else if (msg == 'sharedWorkerEvent') {
                switch (dataParse['name']) {
                  case 'updateTime':
                    self.$root.$emit('realtimeStatusTime', dataParse['time']);
                    break;
                }
              }
            }
          },
          false
        );
        this.WorkerIO.port.addEventListener(
          'error',
          function (e) {
            throw new Error('WorkerIO Error: could not open SharedWorker', e);
          },
          false
        );
      }
    },
    async getDashboard() {
      let url = `/api/desktop/dashboard`;
      return await requestService
        .GetFetch('ccp', url)
        .then((response) => {
          if (response.status == 200) {
            response.text().then((text) => {
              let self = this;
              const data = text && JSON.parse(text);
              if (data.data != null) {
                // let sumQueues = 0;
                let dataCountAllQueue = data.data.count_all_queue;
                let mapArrayOne = new Map(dataCountAllQueue.map((obj) => [obj._id, obj]));
                let mappedObjects = this.allQueue.map((obj) => mapArrayOne.get(obj._id));
                // mappedObjects.forEach((e) => {
                //   sumQueues += e.jobCount;
                // });
                // self.$root.$emit('setRealtimeAllQueues', mappedObjects);
                // console.log('sumQueues: ', sumQueues, mappedObjects)
                data.data.filterAllQueue = mappedObjects
                self.$root.$emit('setRealtimeDashboard', data.data);
                // console.log('agent: ', data.data)
              }
            });
          }
        })
        .catch((err) => {
          this.$swal.fire({ icon: 'error', title: 'Try Again', text: err });
        });
    },
    async getJobPending() {
      let url = `/api/desktop/pending/job`;
      return await requestService
        .GetFetch('ccp', url)
        .then((response) => {
          if (response.status == 200) {
            response.text().then((text) => {
              let self = this;
              const data = text && JSON.parse(text);
              if (data.data != null) {
                let jobData = data.data;
                jobData.forEach((element, index) => {
                  if (element.status == 'In Process') {
                    self.tab2 = 1;
                    var obj = {};
                    obj['mail_id'] = element['_id'];
                    self.$root.$emit('setSelectMail', element['_id']);
                    self.$root.$emit('notificationToAgent', obj);
                    self.$root.$data.WorkerIO.port.postMessage([
                      'changeStatus',
                      'acd',
                    ]);
                    jobData.splice(index, 1);
                    return;
                  }
                });
                self.$root.$emit('setAgentDesktopJob', jobData);
              } else {
                self.$root.$emit('setAgentDesktopJob', []);
              }
            });
          }
        })
        .catch((err) => {
          this.$swal.fire({ icon: 'error', title: 'Try Again', text: err });
        });
    },
    getClass(history, show) {
      return {
        'col-8': history == 1,
        'col-12': history != 1,
        // 'ml-3': show,
      };
    },
    linkClass(id, idx) {
      if (id == idx) {
        return ['bg-none', 'text-primary', 'tab-transition-active'];
      } else {
        return ['text-dark', 'tab-transition'];
      }
    },
  },
};
</script>

<style>
.tab-transition-active:after {
  content: '';
  display: block;
  width: 100%;
  margin-top: 0.6em;

  border-bottom: 1px solid #2971ff;
}

.tab-transition:after {
  content: '';
  display: block;
  margin-top: 0.6em;
  animation: widthOut 0.2s ease-in-out;
  width: 0%;
  border-bottom: 1px solid;
}

.tab-transition:hover:after {
  animation: widthIn 0.2s ease-in-out;
  width: 100%;
}

@keyframes widthOut {
  0% {
    width: 100%;
  }

  100% {
    width: 0%;
  }
}

@keyframes widthIn {
  from {
    width: 0%;
  }

  to {
    width: 100%;
  }
}

.row [class*='col-'] {
  transition: all 0.4s cubic-bezier(0.6, 0.15, 0.35, 0.8);
}

.fade-move {
  transition: all 0.5s;
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 200ms;
  transition-timing-function: cubic-bezier(0.6, 0.15, 0.35, 0.8);
}

.fade-enter,
.fade-leave-to {
  transform: translateX(-20px);
  opacity: 0;
}

.history-move {
  transition: all 0.5s;
}

.history-enter-active {
  transition-delay: 0.3s;
  transition-duration: 0.5s;
  transition-timing-function: cubic-bezier(0.6, 0.15, 0.35, 0.8);
}

.history-enter,
.history-leave-to {
  /* transform: translateX(20px); */
  opacity: 0;
}

.tab-content>.active {
  display: block;
  animation: takeIn 0.5s ease-in-out;
  position: relative;
}

@keyframes takeIn {
  0% {
    opacity: 0;
  }

  50% {
    transform: translateY(20px);
    opacity: 0;
  }

  100% {
    transform: translateY(0px);
    opacity: 1;
  }
}

.col-0 {
  width: 100%;
  max-width: 0%;
  opacity: 0;
}

.nav-link {
  padding: 0.5rem 0.393rem !important;
}

.overflow-scroll {
  height: 69vh !important;
}
</style>
